export const STUDENT_DEMOGRAPHICS_DETAILS_LABELS = {
  HEADING: 'Student Demographic Details',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  USERNAME: 'Username',
  GRADE: 'Grade',
  PARENT_NAME: 'Parent Name',
  RM_NAME: 'RM Name',
  ASSIGNED_REGION: 'Assigned Region',
  ID: 'ID',
  STATE: 'State',
  REFERRAL_LINK: 'Referral Link',
  STUDENT_SERVICE_ID: 'Student Service ID',
  SOURCE: 'Source',
};
export const CONTACT_DETAILS_LABELS = {
  HEADING: 'Contact Details',
  COUNTRY_CODE: 'Country Code',
  PHONE: 'Phone',
  EMAIL: 'Email',
};
export const IDENTIFIERS_LABELS = {
  HEADING: 'Identifiers',
  TEST_ACCOUNT: 'Test Account',
  TRAINING_ACCOUNT: 'Training Account',
  REMOVE_REGION_BANNER: 'Payment Region Mismatch',
};
export const ACTIONS_LABELS = {
  HEADING: 'Actions',
  EDIT_LEAP_USERNAME: 'Edit Leap Username',
  ASSIGN_RM: 'Assign RM',
  EDIT_STUDENT_DETAILS: 'Edit Student Details',
  ASSIGN_REGION: 'Assign Region',
  EDIT_PHONE_NO: 'Edit Phone Number',
};
export const FIELD_TYPE = {
  FIELD: 'field',
  LINK: 'link',
};
export const STUDENT_TYPE = 'STUDENT';
export const IDENTIFIER_VALUES = {
  YES: 'Yes',
  NO: 'No',
};
